const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgLogoPepper2022(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1125 1388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0386e8;}.cls-2{fill:#3658e2;}.cls-3{fill:#37a8ed;}.cls-4{fill:#03c4f7;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo Pepper") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.71,1276.84v84.56H346V947.52C144.46,947.52,16.71,1112.07,16.71,1276.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M653,20.33h0c141.38,0,303.83,113.75,303.83,323.19,0,140.24-131.51,292.23-308.4,292.23H346.32s-102.14-10.61-208.74,74.77C19.2,805.34,16.88,945.71,16.72,947.44v329.4c0-164.77,127.75-329.32,329.32-329.32h299.5c241.47,0,463.76-193.77,463.76-463.76C1109.29,179,845.46,20.33,653,20.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M956.84,343.52c0-85.18-26.87-154.53-68.27-206.84,16.72,39.55,26.2,99.55,21.17,145.1-10.57,95.84-56.5,168.69-115.15,212.74-3,78.1-66.12,141.23-146.15,141.23C825.33,635.75,956.84,483.76,956.84,343.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M792.89,511.39c.19-1.25.41-2.49.57-3.75C793.3,508.9,793.08,510.14,792.89,511.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M794.67,489.51c0,3.21-.27,6.35-.47,9.5.1-1.5.33-3,.39-4.49,58.65-44,104.58-116.9,115.15-212.74,5-45.55-4.45-105.55-21.17-145.1a305.1,305.1,0,0,0-33.22-35.61c-7.4,69.08-39.37,185.2-162,249.29A146.24,146.24,0,0,1,794.67,489.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M648.44,635.75q7.54,0,14.88-.74C658.43,635.49,653.47,635.75,648.44,635.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M790.68,523.24a3.38,3.38,0,0,1,.08-.34C790.74,523,790.7,523.12,790.68,523.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M676.53,633c.35-.06.72-.09,1.06-.16C677.25,633,676.88,633,676.53,633Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M733.92,32.33c-27.18-7.76-43.25-10.06-70.37-11.73-1.48-.09-12.07-.6-18-.6H16.71V947.52S17,916.27,30,873c.51-1.73,1.08-3.5,1.63-5.26.24-.76.46-1.5.7-2.27,15.24-47.42,45.4-107,105.27-155a329,329,0,0,1,39.15-27.47c91.12-55.43,169.55-47.31,169.59-47.31V343.27H648.44a146.05,146.05,0,0,1,44.88,7.09C816,286.27,848,170.15,855.35,101.07,855.35,101.07,804.88,52.6,733.92,32.33Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPepper2022);
export default __webpack_public_path__ + "static/media/Logo_Pepper_2022.eb999846dc5b02564dd1e1131d1e6066.svg";
export { ForwardRef as ReactComponent };